import * as React from 'react';
import { Field, formValueSelector, InjectedFormProps, reduxForm, reset } from 'redux-form';
import { flow, isEmpty, map } from 'lodash';
import { connect } from 'react-redux';
import { IStore } from '../../../../../redux/IStore';
import { bindActionCreators } from 'redux';
import { actions as authActions, IAuthActions } from '../../../../../services/auth/reducer';
import { Button, Col, Form, ModalBody, ModalHeader, ModalTitle, Row } from 'react-bootstrap';
import { Modal as BootstrapModal } from 'react-bootstrap/lib';
import { FaSpinner } from 'react-icons/fa';
import { actions as modalActions } from '../../../../../services/modal/reducer';
import { IModalActions, IModalState } from '../../../../../services/modal/model';
import { IDocument } from '../../../../../data/api/models';
import { CheckboxGroup } from './Components/CheckboxGroup';

const FORM_NAME = 'downloadDocumentsForm';

interface IDownloadDocumentsButtonProps extends InjectedFormProps<any> {
  formValues: any;
  policy: any;
  renewal: any;
  modal: IModalState;
  disabled: boolean;
  actions: {
    auth: IAuthActions;
    reset(formName: string);
    modal: IModalActions;
  };
}

interface IDownloadDocumentsState {
  documentsToDownload: any[];
  submittingForm: boolean;
}

class DownloadDocumentsButton extends React.Component<IDownloadDocumentsButtonProps, IDownloadDocumentsState> {

  public state = {
    documentsToDownload: [],
    submittingForm: false,
  }

  handleSubmit = (values) => {
    const { actions, policy, renewal } = this.props;
    const payload = {
      meta: {
        documents: map(values.selectedDocs, (value, key) => {
          if (value) {
            return key;
          }
        }).filter((data) => !!data),
      },
    };

    if (isEmpty(payload.meta.documents)) {
      return;
    }

    let resourceType = null
    let resourceId = null;

    if (policy) {
      resourceId = policy.id;
      resourceType = 'policy'
    }

    if (renewal) {
      resourceId = renewal.id;
      resourceType = 'renewal'
    }

    this.setState({ submittingForm: true })

    Promise.resolve(actions.auth.downloadDocuments(payload, resourceType, resourceId)).then((data) => {
      this.setState({ submittingForm: false })
      this.handleClose();
    });
  }

  private emptySelection = (): boolean => {
    const { formValues } = this.props;

    const selection = map(formValues, (value, key) => {
      if (value) {
        return key;
      }
    }).filter((data) => !!data)

    return isEmpty(selection);
  }

  handleOpen = () => {
    const { change, actions } = this.props;
    actions.reset(FORM_NAME);
    this.getDocuments();
    this.getDocuments().map((document, documentIndex) => {
      change('selectedDocs[' + document.id + ']', true);
    });
    actions.modal.openDocumentsDownloadModal();
  }

  private handleClose = () => {
    const { actions } = this.props;
    actions.modal.closeDocumentsDownloadModal();
    actions.reset(FORM_NAME);
  }

  getDocuments = (): { name: string, id: string }[] => {
    const { policy, renewal } = this.props;

    if (policy) {
      return this.getPolicyDocuments(policy);
    }

    if (renewal) {
      return this.getRenewalDocuments(renewal)
    }
  }

  private getRenewalDocuments = (renewal) => {
    const documents = renewal.documents;

    const quoteDocumentsSortOrder = [
      'Quotation',
      'Medical Declaration',
      'Insurance Product Information Document',
      'Policy Wording',
      'Terms of Business Customer Agreement',
    ];
    const quoteDocuments = this.sortByDocumentType(documents.filter((document: IDocument) => {
      return quoteDocumentsSortOrder.includes(document.documentType);
    }), quoteDocumentsSortOrder);

    return quoteDocuments.map((document) => {
      return { name: document.displayName, id: document.id }
    });

  }

  private getPolicyDocuments = (policy: any) => {
    const sortOrder = [
      'Policy Holder Letter',
      'Certificate',
      'Medical Declaration',
      'Insurance Product Information Document',
      'Policy Wording',
      'Terms of Business Customer Agreement',
    ];
    const documents = this.sortByDocumentType(policy.documents, sortOrder);

    return documents.map((document) => {
      return { name: document.displayName, id: document.id }
    });
  }

  public sortByDocumentType = (documents: IDocument[], sortOrder: string[]) => {
    const ordering = {};
    for (let i = 0; i < sortOrder.length; i++) {
      ordering[sortOrder[i]] = i;
    }

    return documents.sort((a, b) => {
      return (ordering[a.documentType] - ordering[b.documentType]);
    });
  }

  render() {
    const {
      handleSubmit,
      submitting,
      submitFailed,
      valid,
      modal,
      disabled,
    } = this.props;

    const { submittingForm } = this.state;

    return (
      <>
        <>
          <Button
            bsStyle="primary"
            block={true}
            className={'functional-button full-width'}
            disabled={disabled}
            onClick={this.handleOpen}
          >DOWNLOAD DOCUMENTS</Button>
        </>
        <>
          <BootstrapModal
            show={modal.documentsDownloadModal.opened}
            onHide={this.handleClose}
            keyboard={false}
            backdrop="static"
          >
            <ModalHeader closeButton={true}>
              <ModalTitle>{'DOWNLOAD DOCUMENTS'}</ModalTitle>
            </ModalHeader>
            <ModalBody>
              <Form horizontal={true} autoComplete="off" onSubmit={handleSubmit(this.handleSubmit)}>
                <div className="form-horizontal">
                  <Row>
                    {this.getDocuments().map((document, documentIndex) => {
                      return (
                        <Col xs={12} key={documentIndex} className={'document-list'}>
                          <div className={'checkbox-container'}>
                            <div className={'checkbox-element'}>
                              <Field
                                inline={true}
                                options={[
                                  { label: document.name, value: true },
                                ]}
                                name={'selectedDocs[' + document.id + ']'}
                                component={CheckboxGroup}
                              />
                            </div>
                          </div>
                        </Col>
                      );
                    })}
                  </Row>
                </div>

                <Row>
                  <Col xs={6} style={{ marginTop: '15px' }}>
                    <Button
                      bsStyle="default"
                      block={true}
                      className={'medium-width functional-button pull-left'}
                      disabled={submittingForm}
                      onClick={this.handleClose}
                    >CLOSE</Button>
                  </Col>
                  <Col xs={6} style={{ marginTop: '15px' }}>
                    <Button
                      id="continue"
                      bsStyle="primary"
                      className="medium-width functional-button pull-right"
                      type={'submit'}
                      disabled={submitting || (submitFailed && !valid) || this.emptySelection() || submittingForm}
                    >
                      {submitting && (
                        <FaSpinner className="fa-spin"/>
                      )}
                      DOWNLOAD
                    </Button>
                  </Col>
                </Row>
              </Form>
            </ModalBody>
          </BootstrapModal>
        </>
      </>
    );
  }
}

let selector;

export default flow([
  reduxForm({
    form: FORM_NAME,
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true,
  }),
  (component) => {
    selector = formValueSelector(FORM_NAME);
    return component;
  },
  connect(
    (state: IStore) => {
      const values = selector(
        state,
        'selectedDocs',
      );
      return {
        modal: state.modal,
        formValues: values,
      };
    },
    (dispatch) => ({
      actions: {
        auth: bindActionCreators({ ...authActions }, dispatch),
        reset: bindActionCreators(reset, dispatch),
        modal: bindActionCreators({ ...modalActions }, dispatch),
      },
    }),
  ),
])(DownloadDocumentsButton);

